import { Component, h, Host, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-badge',
    styleUrl: 'lilu-badge.scss',
    shadow: true
})
export class LiluBadge {

    @Prop() size = 'size-sm';
    @Prop() appearance: '' | 'edge' = '';
    @Prop() color = 'red'

    render() {
        return (
            <Host>
                <span class={`${this.size} ${this.color} ${this.appearance}`}>
                    <slot></slot>
                </span>
            </Host>
        );
    }
}
